{
  "metadata": {
    "id": "palenight-dark",
    "name": "Palenight",
    "description": "Портировано из темы «Palenight» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "palenight.json",
      "project": "whizkydee",
      "url": "https://github.com/whizkydee/vscode-palenight-theme",
      "upstreamFile": "packages/ui/src/theme/themes/palenight.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.475,
      "paletteMaxS": 0.523,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 27.4,
      "syntaxVsTextMinDeltaE": 5.5,
      "chartsMinDeltaE": 30.9,
      "textSeparationDeltaE": 10.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#82aaff",
      "hover": "#91b4ff",
      "active": "#9bbbff",
      "foreground": "#000000",
      "muted": "#82aaff80",
      "emphasis": "#82aaff"
    },
    "surface": {
      "background": "#292d3e",
      "foreground": "#ced2e4",
      "muted": "#3a3f52",
      "mutedForeground": "#b3b6ca",
      "elevated": "#43485d",
      "elevatedForeground": "#b3b8d4",
      "raised": "#585d74",
      "raisedForeground": "#d4d7e7",
      "overlay": "#292d3ecc",
      "subtle": "#313648"
    },
    "interactive": {
      "border": "#5d6279",
      "borderHover": "#4c5166",
      "borderFocus": "#82aaff",
      "selection": "#a6accd29",
      "selectionForeground": "#a6accd",
      "focus": "#82aaff59",
      "focusRing": "#82aaff61",
      "cursor": "#a6accd",
      "hover": "#a6accd1c",
      "active": "#a6accd29"
    },
    "status": {
      "error": "#f07178",
      "errorForeground": "#000000",
      "errorBackground": "#f0717824",
      "errorBorder": "#f0717873",
      "warning": "#ffcb6b",
      "warningForeground": "#000000",
      "warningBackground": "#ffcb6b24",
      "warningBorder": "#ffcb6b73",
      "success": "#c3e88d",
      "successForeground": "#000000",
      "successBackground": "#c3e88d24",
      "successBorder": "#c3e88d73",
      "info": "#f78c6c",
      "infoForeground": "#000000",
      "infoBackground": "#f78c6c24",
      "infoBorder": "#f78c6c73"
    },
    "pr": {
      "open": "#c3e88d",
      "draft": "#c1c4d4",
      "blocked": "#ffcb6b",
      "merged": "#89ddff",
      "closed": "#f07178"
    },
    "syntax": {
      "base": {
        "background": "#4c5167",
        "foreground": "#a6accd",
        "comment": "#c1c4d4",
        "keyword": "#dbb8f1",
        "string": "#c3e88d",
        "number": "#fab6a1",
        "function": "#89ddff",
        "variable": "#c0c4dc",
        "type": "#ffcb6b",
        "operator": "#89ddff"
      },
      "tokens": {
        "commentDoc": "#c1c4d4",
        "stringEscape": "#89ddff",
        "keywordImport": "#dbb8f1",
        "storageModifier": "#dbb8f1",
        "functionCall": "#89ddff",
        "method": "#89ddff",
        "variableProperty": "#89ddff",
        "variableOther": "#c0c4dc",
        "variableGlobal": "#fab6a1",
        "variableLocal": "#89ddff",
        "parameter": "#c0c4dc",
        "constant": "#fab6a1",
        "class": "#ffcb6b",
        "className": "#ffcb6b",
        "interface": "#ffcb6b",
        "struct": "#ffcb6b",
        "enum": "#ffcb6b",
        "typeParameter": "#ffcb6b",
        "namespace": "#ffcb6b",
        "module": "#dbb8f1",
        "tag": "#dbb8f1",
        "jsxTag": "#dbb8f1",
        "tagAttribute": "#89ddff",
        "tagAttributeValue": "#c3e88d",
        "boolean": "#fab6a1",
        "decorator": "#dbb8f1",
        "label": "#89ddff",
        "regexp": "#c3e88d"
      }
    },
    "charts": {
      "series": [
        "#82aaff",
        "#f78c6c",
        "#c3e88d",
        "#ffcb6b",
        "#e6b6a4"
      ]
    },
    "chat": {
      "background": "#292d3e",
      "userMessage": "#e4e6f0",
      "userMessageBackground": "#43485d",
      "assistantMessage": "#c0c4dc",
      "assistantMessageBackground": "#3a3f52",
      "timestamp": "#c1c4d4",
      "divider": "#5d6279",
      "typing": "#c1c4d4"
    },
    "loading": {
      "spinner": "#82aaff",
      "spinnerTrack": "#3a3f52",
      "skeleton": "#3a3f52",
      "shimmer": "#51566d"
    },
    "tools": {
      "background": "#3a3f52",
      "border": "#5d6279",
      "headerHover": "#50566c",
      "icon": "#82aaff",
      "title": "#a6accd",
      "description": "#c1c4d4",
      "edit": {
        "added": "#c3e88d",
        "addedBackground": "#c3e88d24",
        "removed": "#f07178",
        "removedBackground": "#f0717824",
        "modified": "#f78c6c",
        "modifiedBackground": "#f78c6c24",
        "lineNumber": "#c1c4d4"
      }
    },
    "markdown": {
      "heading1": "#a6accd",
      "heading2": "#a6accd",
      "heading3": "#a6accd",
      "heading4": "#a6accd",
      "link": "#82aaff",
      "linkHover": "#91b4ff",
      "inlineCode": "#c3e88d",
      "inlineCodeBackground": "#3a3f52",
      "blockquote": "#c1c4d4",
      "blockquoteBorder": "#5d6279",
      "listMarker": "#82aaffbf",
      "bold": "#a6accd",
      "italic": "#a6accde6",
      "strikethrough": "#c1c4d4",
      "hr": "#5d6279"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c0686e",
        "foreground": "#000000",
        "contrast": 5.45
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d2a491",
        "foreground": "#000000",
        "contrast": 9.46
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cfb56a",
        "foreground": "#000000",
        "contrast": 10.47
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#dfdcac",
        "foreground": "#000000",
        "contrast": 14.97
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#abd16c",
        "foreground": "#000000",
        "contrast": 12.07
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#ace2a6",
        "foreground": "#000000",
        "contrast": 14.18
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6ccf7b",
        "foreground": "#000000",
        "contrast": 10.85
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#6dd0b5",
        "foreground": "#000000",
        "contrast": 11.34
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#6bc0ce",
        "foreground": "#000000",
        "contrast": 10.06
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#6399ca",
        "foreground": "#000000",
        "contrast": 6.94
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5b68c5",
        "foreground": "#ffffff",
        "contrast": 4.96
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9a8ecf",
        "foreground": "#000000",
        "contrast": 7.14
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#9e61c7",
        "foreground": "#000000",
        "contrast": 4.99
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d78bd4",
        "foreground": "#000000",
        "contrast": 8.53
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#dba7c8",
        "foreground": "#000000",
        "contrast": 10.37
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#ca6294",
        "foreground": "#000000",
        "contrast": 5.69
      }
    ]
  }
}
